import { render } from "./YieldDistributionPage.vue?vue&type=template&id=3572de3b&scoped=true"
import script from "./YieldDistributionPage.vue?vue&type=script&lang=js"
export * from "./YieldDistributionPage.vue?vue&type=script&lang=js"

import "./YieldDistributionPage.vue?vue&type=style&index=0&id=3572de3b&scoped=true&lang=css"

import exportComponent from "/var/www/cmtycoin.xyz/repo/frontend-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3572de3b"]])

export default __exports__